<div class="history-row">
  <b tabindex="0"> {{ 'submitProposal.selectedText' | translate }} </b>

  @if (historyDetails.otherExamComponents.length && historyDetails.electives.examComponentName) {
    <pa-add-course-list-header
      [title]="historyDetails.electives.examComponentName"
      class="course-list-header__level1"
    />
  }

  @if (historyDetails.electives.individualArrangements.length) {
    <pa-add-course-list-header
      [title]="'submitProposal.coursesIndividualArrangements' | translate"
      tabindex="0"
      [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
    />
    @for (course of historyDetails.electives.individualArrangements; track $index) {
      <pa-history-course-item [course]="course" tabindex="0" />
    }
  }

  @if (historyDetails.electives.courses.length) {
    <pa-add-course-list-header
      [title]="'submitProposal.courses' | translate"
      tabindex="0"
      [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
    />
    @for (course of historyDetails.electives.courses; track $index) {
      <pa-history-course-item [course]="course" tabindex="0" />
    }
  }

  @if (historyDetails.electives.minors.length) {
    @for (minor of historyDetails.electives.minors; track minor.code) {
      @if (!planAllowsChangeExamComponent()) {
        <!-- when placing is done by the SVO, show courses per minor, not per minor exam component -->
        <pa-add-course-list-header
          [title]="minor.name"
          tabindex="0"
          [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
        />
      }
      @for (minorExamComponent of minor.examComponents; track minorExamComponent.id) {
        @if (minorExamComponent.courses.length) {
          @if (planAllowsChangeExamComponent()) {
            <!-- when placing is done in the PlanApp, show individual minor exam components with the minor name between brackets -->
            <pa-add-course-list-header
              [title]="minorExamComponent.name + ' (' + minor.name + ')'"
              tabindex="0"
              [ngClass]="{ 'course-list-header__level2': historyDetails.otherExamComponents.length }"
            />
          }
          @for (course of minorExamComponent.courses; track $index) {
            <pa-history-course-item [course]="course" />
          }
        }
      }
    }
  }

  @if (historyDetails.otherExamComponents.length) {
    @for (examComponent of historyDetails.otherExamComponents; track examComponent.code) {
      @if (examComponent.courses.length) {
        <pa-add-course-list-header [title]="getExamComponentName(examComponent)" class="course-list-header__level1" />

        @for (course of examComponent.courses; track course.id) {
          <pa-history-course-item [course]="course" />
        }
      }
    }
  }
</div>
